import { checkLang, arrayContains } from '../helpers';
import {
  getDeviceID,
  formFormatDob,
  myS4CBaseUrl,
  myS4CApiPatch,
  myS4CPersonalizeBaseUrl,
} from '../mys4c_helpers';
import {
  localStorageAuthToken,
  localStorageAuthTokenExpiry,
  LS_EMAIL,
  localStorageProfileName,
  localStorageProfileId,
  MYS4C_MAIN_PROF_NAME,
  MYS4C_MAIN_PROF_ID,
  MYS4C_PROF_NAME,
  MYS4C_ERROR_UNAUTH,
  VERIFICATION_THRESHOLD,
  MYS4C_UNAUTH_CALLS,
  MYS4C_ERROR_IGNORE,
  localStorageIsChild,
} from '../constants';
import {
  AUTH_USER,
  UNAUTH_USER,
  UNAUTH_USER_ERROR,
  AUTH_ERROR,
  USER_SIGNUP_SUCCESS,
  USER_VERIFY_ERROR,
  USER_VERIFY_SUCCESS,
  USER_DATA_ERROR,
  USER_DATA_SUCCESS,
  USER_DATA_UPDATE_SUCCESS,
  EMAIL_CHANGE_SUCCESS,
  EMAIL_CHANGE_ERROR,
  EMAIL_VERIFY_SUCCESS,
  EMAIL_VERIFY_ERROR,
  GET_MAIL,
  CHANGE_PWORD_SUCCESS,
  CHANGE_PWORD_ERROR,
  FORGOT_PWORD_SUCCESS,
  FORGOT_PWORD_ERROR,
  MAIL_LISTS_SUCCESS,
  MAIL_LISTS_ERROR,
  UPDATE_MAIL_LISTS_SUCCESS,
  UPDATE_MAIL_LISTS_ERROR,
  PROFILES_SUCCESS,
  PROFILES_ERROR,
  PROFILE_DATA_SUCCESS,
  PROFILE_DATA_ERROR,
  PROFILE_DATA_UPDATE_SUCCESS,
  PROFILE_DATA_UPDATE_ERROR,
  PROFILE_DELETE_SUCCESS,
  PROFILE_DELETE_ERROR,
  PROFILE_NAME,
  USER_SIGNUP_ERROR,
  CHANGE_PWORD_LOGEDIN_SUCCESS,
  CHANGE_PWORD_LOGEDIN_ERROR,
  WATCHING_FETCH_DATA_SUCCESS,
  WATCHING_HAS_ERRORED,
  WATCHING_IS_LOADING,
  PROFILE_ID,
  DELETE_USER_SUCCESS,
  FETCH_ADDTOLIST,
  FETCH_ADDTOLIST_ERROR,
  ADD_ADDTOLIST,
  ADD_ADDTOLIST_ERROR,
  REMOVE_ADDTOLIST,
  REMOVE_ADDTOLIST_ERROR,
  PROFILE_ACTIVE_UPDATE,
  FETCH_PC,
  FETCH_PC_ERROR,
  UPDATE_PC_PIN,
  UPDATE_PC_PIN_ERROR,
  DISABLE_PC_PIN,
  DISABLE_PC_PIN_ERROR,
  VERIFY_PC_PIN,
  VERIFY_PC_PIN_ERROR,
  FETCH_ADDTOLIST_LOADING,
  SMART_TV_PROCESS_ERRORED,
  SMART_TV_PROCESS_LOADING,
  SMART_TV_PROCESS_SUCCESS,
  SMART_TV_BROADCAST_SUCCESS,
  SMART_TV_PROCESS_RESET,
  SMART_TV_BROADCAST_RESET,
  RESET_USER_DATA,
  PROFILES_LOADING,
  FETCH_POPULAR_LOADING,
  FETCH_POPULAR_ERROR,
  FETCH_POPULAR,
  FETCH_TRENDING_ERROR,
  FETCH_TRENDING_LOADING,
  FETCH_TRENDING,
  FETCH_TOP_PICKS_ERROR,
  FETCH_TOP_PICKS_LOADING,
  FETCH_TOP_PICKS,
  PROFILE_IS_CHILD,
  FETCH_MORE_LIKE,
  FETCH_MORE_LIKE_LOADING,
  FETCH_MORE_LIKE_ERROR,
} from './types';

import { fetchAutoplayNext } from '.';
import { reset } from 'redux-form';
import { checkEmailAddress } from './EmailVerificationActions';
import { broadcastProcessedPin } from './SmartTVSocketActions';

///////////
// MYS4C //
///////////

// Grab all the myS4C details needed for a programme page
export function fetchProgrammeMyS4C(pid, series_id, num_results, genres) {
  return (dispatch) =>
    Promise.all([
      dispatch(fetchParentControls()),
      dispatch(fetchAddToList()),
      dispatch(fetchAutoplayNext()),
      dispatch(fetchMoreLike(pid, series_id, num_results, genres)),
    ]);
}

/* Start - Parental Control */
export function fetchParentControls() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_pin_status',
    reducerError: FETCH_PC_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: FETCH_PC, payload: itemObj.data.parental_control_flag });
    },
  });
}

export function setParentControls(pin, confPin, password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'enable_parental_control',
    reducerError: UPDATE_PC_PIN_ERROR,
    extraDataObject: {
      parental_control_pin: pin,
      confPin: confPin,
      password: password,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: UPDATE_PC_PIN, payload: true });
    },
  });
}

export function disableParentControls(password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'disable_parental_control',
    reducerError: DISABLE_PC_PIN_ERROR,
    extraDataObject: { password: password },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: DISABLE_PC_PIN, payload: true });
    },
  });
}

export function resetStatusParentControls() {
  return {
    type: DISABLE_PC_PIN,
    payload: null,
  };
}

export function resetUpdatePin() {
  return {
    type: UPDATE_PC_PIN,
    payload: null,
  };
}

export function verifyPin(pin) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'verify_pin',
    reducerError: VERIFY_PC_PIN_ERROR,
    extraDataObject: { parental_control_pin: pin },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: VERIFY_PC_PIN,
        payload: itemObj.data.pin_correct === 'Y' ? true : false,
      });
    },
  });
}

export function resetVerifyPin() {
  return {
    type: VERIFY_PC_PIN,
    payload: null,
  };
}
/* End - Parental Control */

export function getEmail() {
  let email = localStorage.getItem(LS_EMAIL);
  if (email) {
    return {
      type: GET_MAIL,
      payload: email,
    };
  } else {
    return (dispatch) => {
      dispatch(fetchUserData());
    };
  }
}

export function resetForm(formName) {
  return (dispatch) => {
    dispatch(reset(formName));
  };
}
export function resetForgottenPassword() {
  return {
    type: FORGOT_PWORD_SUCCESS,
    payload: false,
  };
}
export function userResetSignUpSuccess() {
  return {
    type: USER_SIGNUP_SUCCESS,
    payload: false,
  };
}
export function userResetUpdateSuccess() {
  return {
    type: USER_DATA_UPDATE_SUCCESS,
    payload: false,
  };
}
export function changeEmailReset() {
  return {
    type: EMAIL_CHANGE_SUCCESS,
    payload: false,
  };
}

export function changePasswordReset() {
  return {
    type: CHANGE_PWORD_SUCCESS,
    payload: null,
  };
}
export function resetDeleteSuccess() {
  return {
    type: DELETE_USER_SUCCESS,
    payload: false,
  };
}

export function signinUser(email, password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'login',
    reducerError: AUTH_ERROR,
    extraDataObject: { email: email, password: password },
    dispatchSuccess: (itemObj, dispatch) => {
      updateTokenLocalStorage(itemObj.token);
      updateProfileLocalStorage(
        itemObj.data[MYS4C_MAIN_PROF_NAME],
        itemObj.data[MYS4C_MAIN_PROF_ID],
        itemObj.data.is_child_account_flag
      );
      dispatch({ type: AUTH_USER, payload: itemObj.token });
      dispatch({
        type: PROFILE_NAME,
        payload: itemObj.data[MYS4C_MAIN_PROF_NAME],
      });
      dispatch({ type: PROFILE_ID, payload: itemObj.data[MYS4C_MAIN_PROF_ID] });
      dispatch({
        type: PROFILE_IS_CHILD,
        payload:
          itemObj.data.is_child_account_flag !== undefined
            ? itemObj.data.is_child_account_flag
            : null,
      });
    },
  });
}

export function signUpUser(
  email,
  name,
  password,
  mail_24228 = false,
  gender,
  postcode,
  preferred_language_iso_code,
  dob_day,
  dob_month,
  dob_year,
  email_passed
) {
  let dob;

  if (dob_year && dob_month && dob_day) {
    dob = `${dob_day}/${dob_month}/${dob_year}`;
  }

  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'create_clic_user',
    reducerError: USER_SIGNUP_ERROR,
    extraDataObject: {
      email: email,
      person_name: name,
      password: password,
      terms_accepted: true,
      mail_24228: mail_24228,
      gender: gender,
      postcode: postcode,
      preferred_language_iso_code: preferred_language_iso_code,
      dob: dob,
      email_passed: email_passed,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      updateTokenLocalStorage(itemObj.token);
      updateProfileLocalStorage(
        itemObj.data[MYS4C_MAIN_PROF_NAME],
        itemObj.data[MYS4C_MAIN_PROF_ID],
        itemObj.data.is_child_account_flag
      );
      dispatch({ type: AUTH_USER, payload: itemObj.token });
      dispatch({
        type: PROFILE_NAME,
        payload: itemObj.data[MYS4C_MAIN_PROF_NAME],
      });
      dispatch({ type: PROFILE_ID, payload: itemObj.data[MYS4C_MAIN_PROF_ID] });
      dispatch({
        type: PROFILE_IS_CHILD,
        payload:
          itemObj.data.is_child_account_flag !== undefined
            ? itemObj.data.is_child_account_flag
            : null,
      });
    },
  });
}

export function verifyUser(email, code, values) {
  // values expected: password, password2, updates, first
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'verify_account',
    reducerError: USER_VERIFY_ERROR,
    extraDataObject: {
      email_address: email,
      verify_code: code,
      password: values.password,
      password2: values.password2,
      ml_mailing_list_1: values.updates,
      ml_mailing_list_2: values.first,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: AUTH_USER, payload: itemObj.token });
      dispatch(fetchUserData());
      dispatch({ type: USER_VERIFY_SUCCESS, payload: true });
    },
  });
}

export function fetchUserData() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_account',
    reducerError: USER_DATA_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      // TODO: Alternate way to do this?
      dispatch({ type: USER_DATA_SUCCESS, item: itemObj.data });
      dispatch(getEmail());
    },
  });
}

export function updateUserData(values) {
  if (values.day && values.month && values.year) {
    values.dob = formFormatDob(`${values.year}-${values.month}-${values.day}`);
  } else {
    values.dob = '';
  }
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'save_account',
    reducerError: USER_DATA_ERROR,
    extraDataObject: values,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: USER_DATA_UPDATE_SUCCESS, payload: true });
      dispatch(fetchUserData());
    },
  });
}

export function signOutUser() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'logout',
    reducerError: UNAUTH_USER_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: UNAUTH_USER });
      dispatch({ type: PROFILE_NAME, payload: '' });
      dispatch({ type: PROFILE_ID, payload: '' });
      dispatch({ type: PROFILE_IS_CHILD, payload: '' });
      dispatch({ type: RESET_USER_DATA });
    },
  });
}

export function signOutUserAll() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'logout_all',
    reducerError: UNAUTH_USER_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: UNAUTH_USER });
      dispatch({ type: PROFILE_NAME, payload: '' });
      dispatch({ type: PROFILE_ID, payload: '' });
      dispatch({ type: PROFILE_IS_CHILD, payload: '' });
    },
  });
}

export function deleteUser(password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'delete_account',
    reducerError: UNAUTH_USER_ERROR,
    extraDataObject: { password: password },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: DELETE_USER_SUCCESS, payload: true });
      dispatch({ type: UNAUTH_USER });
      dispatch({ type: PROFILE_NAME, payload: '' });
      dispatch({ type: PROFILE_ID, payload: '' });
      dispatch({ type: PROFILE_IS_CHILD, payload: '' });
    },
  });
}
export function verifySmartTVPin(pin) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'link_device_to_account',
    reducerError: SMART_TV_PROCESS_ERRORED,
    reducerIsLoading: SMART_TV_PROCESS_LOADING,
    extraDataObject: { pin: pin },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: SMART_TV_PROCESS_SUCCESS, payload: itemObj.data });
    },
  });
}
export function changeEmail(email, password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'update_email',
    reducerError: EMAIL_CHANGE_ERROR,
    extraDataObject: { password: password, email_address: email },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: EMAIL_CHANGE_SUCCESS, payload: true });
    },
  });
}
export function verifyChangeEmail(email, code) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'verify_account',
    reducerError: EMAIL_VERIFY_ERROR,
    extraDataObject: { verifyEmailAddress: email, verifyCode: code },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: EMAIL_VERIFY_SUCCESS, item: itemObj.data });
    },
  });
}
export function changePassword(email, verifyCode, password) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'save_new_password',
    reducerError: CHANGE_PWORD_ERROR,
    extraDataObject: {
      email: email,
      verifyCode: verifyCode,
      password: password,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      updateTokenLocalStorage(itemObj.token);
      updateProfileLocalStorage(
        itemObj.data[MYS4C_MAIN_PROF_NAME],
        itemObj.data[MYS4C_MAIN_PROF_ID]
      );
      dispatch({ type: AUTH_USER, payload: itemObj.token });
      dispatch({
        type: PROFILE_NAME,
        payload: itemObj.data[MYS4C_MAIN_PROF_NAME],
      });
      dispatch({ type: PROFILE_ID, payload: itemObj.data[MYS4C_MAIN_PROF_ID] });
      dispatch({ type: CHANGE_PWORD_SUCCESS, payload: itemObj.data });
    },
  });
}
export function forgottenPassword(email) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'reset_pw_email_address',
    reducerError: FORGOT_PWORD_ERROR,
    extraDataObject: { email: email },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: FORGOT_PWORD_SUCCESS, payload: true });
    },
  });
}

export function checkEmailAddressAndSignUp(
  email,
  name,
  password,
  mail_24228,
  gender,
  postcode,
  preferred_language_iso_code,
  dob_day,
  dob_month,
  dob_year
) {
  return (dispatch, getState) => {
    return dispatch(checkEmailAddress(email)).then(() => {
      const emailCheck = getState().emailCheck.success;
      let emailPassed = false;
      if (emailCheck && !emailCheck.error) {
        let score = 1;
        if (emailCheck && emailCheck.score) {
          score = emailCheck.score;
        }
        let booleanTest =
          emailCheck.format_valid &&
          emailCheck.mx_found &&
          emailCheck.smtp_check;
        emailPassed = score > VERIFICATION_THRESHOLD && booleanTest;
      }
      return dispatch(
        signUpUser(
          email,
          name,
          password,
          mail_24228,
          gender,
          postcode,
          preferred_language_iso_code,
          dob_day,
          dob_month,
          dob_year,
          emailPassed
        )
      );
    });
  };
}

export function processSmartTVPin(pin, V2 = false) {
  return (dispatch, getState) => {
    return dispatch(verifySmartTVPin(pin)).then(() => {
      // Test here for the two values we need
      // grab response item
      const pinResponse = getState().smartPinProcess.success;
      if (
        pinResponse &&
        pinResponse.socket_id &&
        pinResponse.other_device_token
      ) {
        return dispatch(
          broadcastProcessedPin(
            pinResponse.socket_id,
            pinResponse.other_device_token,
            (itemObj, dispatch) => {
              dispatch({ type: SMART_TV_BROADCAST_SUCCESS, payload: true });
            },
            V2
          )
        );
      }
    });
  };
}

export function processSmartTVProcessPinReset() {
  return {
    type: SMART_TV_PROCESS_RESET,
  };
}

export function processSmartTVBroadcastPinReset() {
  return {
    type: SMART_TV_BROADCAST_RESET,
  };
}

export function fetchMailLists() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_mailing_list_subs',
    reducerError: MAIL_LISTS_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: MAIL_LISTS_SUCCESS, item: itemObj.data });
    },
  });
}

export function updateMailListsSuccess() {
  return {
    type: UPDATE_MAIL_LISTS_SUCCESS,
    payload: false,
  };
}

export function updateMailLists(id, subscribe) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'up_mail_list_sub',
    reducerError: UPDATE_MAIL_LISTS_ERROR,
    extraDataObject: { id: id, subscribe_flag: subscribe },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: UPDATE_MAIL_LISTS_SUCCESS, payload: true });
      dispatch(fetchMailLists());
    },
  });
}

export function fetchProfiles() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_profiles',
    reducerIsLoading: PROFILES_LOADING,
    reducerError: PROFILES_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: PROFILES_SUCCESS, payload: itemObj.data });
    },
  });
}

export function resetFetchProfiles() {
  return {
    type: PROFILES_SUCCESS,
    payload: {},
  };
}

export function setProfile(profileId, profActiveUpdate = false) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'select_active_profile',
    reducerError: AUTH_ERROR,
    extraDataObject: { profile_id: profileId },
    dispatchSuccess: (itemObj, dispatch) => {
      updateProfileLocalStorage(
        itemObj.data[MYS4C_PROF_NAME],
        profileId,
        itemObj.data.is_child_account_flag
      );
      dispatch({ type: AUTH_USER, payload: itemObj.token });
      dispatch({ type: PROFILE_NAME, payload: itemObj.data[MYS4C_PROF_NAME] });
      dispatch({ type: PROFILE_ID, payload: profileId });
      dispatch({ type: PROFILE_ACTIVE_UPDATE, payload: profActiveUpdate });
      dispatch({
        type: PROFILE_IS_CHILD,
        payload: itemObj.data.is_child_account_flag,
      });
    },
  });
}

export function resetSetProfileSuccess() {
  return {
    type: PROFILE_ACTIVE_UPDATE,
    payload: false,
  };
}

export function fetchProfileData(profile_id) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_profile',
    reducerError: PROFILE_DATA_ERROR,
    extraDataObject: { id: profile_id },
    dispatchSuccess: (itemObj, dispatch) => {
      //Format the isChild property for the form
      itemObj.data.is_child_account_flag =
        itemObj.data.is_child_account_flag === 'Y' ||
        itemObj.data.is_child_account_flag === true
          ? true
          : false;
      //Format the date for the damn form
      dispatch({ type: PROFILE_DATA_SUCCESS, item: itemObj.data });
    },
  });
}

export function deleteProfileData(profile_id) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'delete_profile',
    reducerError: PROFILE_DELETE_ERROR,
    extraDataObject: { id: profile_id },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: PROFILE_DELETE_SUCCESS, payload: true });
    },
  });
}

export function updateProfileData(values) {
  if (values.day && values.month && values.year) {
    values.dob = formFormatDob(`${values.year}-${values.month}-${values.day}`);
  } else {
    values.dob = '';
  }

  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'save_profile',
    reducerError: PROFILE_DATA_UPDATE_ERROR,
    extraDataObject: values,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: PROFILE_DATA_UPDATE_SUCCESS, payload: true });
      dispatch(fetchProfileData(itemObj.data.profile_id));
    },
  });
}

export function profileResetUpdateSuccess() {
  return {
    type: PROFILE_DATA_UPDATE_SUCCESS,
    payload: false,
  };
}

export function profileResetAdd() {
  return {
    type: PROFILE_DATA_SUCCESS,
    item: {},
  };
}

export function profileResetDeleteSuccess() {
  return {
    type: PROFILE_DELETE_SUCCESS,
    payload: false,
  };
}

/* This update password is for when you are logged in */
export function changePasswordLoggedIn(
  old_password,
  new_password,
  confirm_new_password
) {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'change_password',
    reducerError: CHANGE_PWORD_LOGEDIN_ERROR,
    extraDataObject: {
      old_password: old_password,
      new_password: new_password,
      confirm_new_password: confirm_new_password,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: CHANGE_PWORD_LOGEDIN_SUCCESS, payload: true });
    },
  });
}

export function resetAPIErrors(type) {
  return function (dispatch) {
    dispatch({ type: type, payload: false });
  };
}

export function fetchWatching() {
  return fetchMyS4CApiData({
    method: 'POST',
    proc: 'get_watching_list',
    reducerIsLoading: WATCHING_IS_LOADING,
    reducerError: WATCHING_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: WATCHING_FETCH_DATA_SUCCESS,
        payload: formatWatchingData(itemObj.data.watching_list),
      });
    },
  });
}

export function formatWatchingData(data) {
  let cardItems = [],
    title;
  if (Object.keys(data).length > 0) {
    Object.entries(data).forEach(([key, value]) => {
      title =
        value.series_title === '' ? value.programme_title : value.series_title;
      cardItems[key] = {
        id: value.programme_id,
        title: title,
        subTitle: value.programme_title,
        thumbnail: value.web_image,
        days: value.days,
        duration: value.duration,
        last_played_date: value.last_played_date,
        last_player_pos: value.last_player_pos,
        series_id: value.series_id,
      };
    });
  }
  return cardItems;
}

export function formatMyListData(data) {
  let cardItems = [];
  if (Object.keys(data).length > 0) {
    Object.entries(data).forEach(([key, value]) => {
      cardItems[key] = {
        id: value.programme_id,
        series_id: value.series_id,
        fav_id: value.fav_id,
        title: value.title,
        thumbnail: value.web_image,
        no_items_avail_flag: value.no_items_avail_flag,
        final_item_watched_flag: value.final_item_watched_flag,
        available:
          value.no_items_avail_flag === 'Y' || value.prog_id === null
            ? false
            : true,
      };
    });
  }
  return cardItems;
}

/* Add to list */
export function fetchAddToList() {
  return fetchMyS4CApiData({
    proc: 'get_favs_list',
    reducerIsLoading: FETCH_ADDTOLIST_LOADING,
    reducerError: FETCH_ADDTOLIST_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: FETCH_ADDTOLIST,
        payload: formatMyListData(itemObj.data.fav_list),
      });
    },
  });
}

export function addAddToList(id) {
  return fetchMyS4CApiData({
    proc: 'add_to_favs',
    reducerError: ADD_ADDTOLIST_ERROR,
    extraDataObject: { id },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchAddToList());
      dispatch({ type: ADD_ADDTOLIST, payload: true });
    },
  });
}

export function removeAddToList(id) {
  return fetchMyS4CApiData({
    proc: 'remove_from_favs',
    reducerError: REMOVE_ADDTOLIST_ERROR,
    extraDataObject: { id },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchAddToList());
      dispatch({ type: REMOVE_ADDTOLIST, payload: true });
    },
  });
}

export function resetAddToList() {
  return {
    type: ADD_ADDTOLIST,
    payload: null,
  };
}

export function resetRemoveToList() {
  return {
    type: REMOVE_ADDTOLIST,
    payload: null,
  };
}

/**
 * FETCH HELPERS
 */

function updateTokenLocalStorage(token) {
  localStorage.removeItem(localStorageAuthToken);
  localStorage.removeItem(localStorageAuthTokenExpiry);

  localStorage.setItem(localStorageAuthToken, token);

  const expiryDate = new Date();
  expiryDate.setFullYear(expiryDate.getFullYear() + 20);

  localStorage.setItem(localStorageAuthTokenExpiry, expiryDate.toISOString());
}

function updateProfileLocalStorage(name, id, childFlag = 'N') {
  localStorage.removeItem(localStorageProfileName);
  localStorage.setItem(localStorageProfileName, name);
  localStorage.removeItem(localStorageProfileId);
  localStorage.setItem(localStorageProfileId, id);

  //Need to update the child account flag here
  localStorage.removeItem(localStorageIsChild);
  localStorage.setItem(localStorageIsChild, childFlag);
}

function isUnauthErrorMessage(errorMessage) {
  return arrayContains(errorMessage, MYS4C_ERROR_UNAUTH);
}

function buildAPIDataObject(lang, extraDataObject) {
  // Build base data object
  const devId = getDeviceID(),
    authId = localStorage.getItem(localStorageAuthToken),
    langApi = checkLang(lang, true),
    apiPath = myS4CApiPatch();

  let dataObject = {
    token: authId,
    advertising_id: devId,
    current_client_lang_iso_code: langApi,
    path: apiPath,
  };

  if (
    localStorage.getItem(localStorageIsChild) &&
    localStorage.getItem(localStorageIsChild).length > 0
  ) {
    dataObject.child_account =
      localStorage.getItem(localStorageIsChild) === 'Y' ? true : false;
  }

  if (extraDataObject && extraDataObject !== 0) {
    dataObject = Object.assign(dataObject, extraDataObject);
  }
  return dataObject;
}

export function formatPersonalizeData(data) {
  let cardItems = [];
  if (Object.keys(data).length > 0) {
    Object.entries(data).forEach(([key, value]) => {
      cardItems[key] = {
        id: value.id,
        series_id: value.series_id,
        fav_id: value.fav_id,
        title: value.series_title ? value.series_title : value.programme_title,
        subTitle: value.programme_title
          ? value.programme_title
          : value.clic_aired,
        thumbnail: value.thumbnail_url,
        recommendationId: value.recommendationId,
      };
    });
  }
  return cardItems;
}

export function fetchPopularList() {
  return fetchMyS4CApiData({
    reducerIsLoading: FETCH_POPULAR_LOADING,
    reducerError: FETCH_POPULAR_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: FETCH_POPULAR,
        payload: formatPersonalizeData(itemObj.data.popular),
      });
    },
    urlOverride: `${myS4CPersonalizeBaseUrl()}/popular`,
  });
}

export function fetchTrendingList() {
  return fetchMyS4CApiData({
    reducerIsLoading: FETCH_TRENDING_LOADING,
    reducerError: FETCH_TRENDING_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: FETCH_TRENDING,
        payload: formatPersonalizeData(itemObj.data.trending),
      });
    },
    urlOverride: `${myS4CPersonalizeBaseUrl()}/trending`,
  });
}

export function fetchTopPicksList() {
  return fetchMyS4CApiData({
    reducerIsLoading: FETCH_TOP_PICKS_LOADING,
    reducerError: FETCH_TOP_PICKS_ERROR,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: FETCH_TOP_PICKS,
        payload: formatPersonalizeData(itemObj.data.top_picks),
      });
    },
    urlOverride: `${myS4CPersonalizeBaseUrl()}/top_picks`,
  });
}

export function fetchMoreLike(pid, series_id, num_results, genres) {
  return fetchMyS4CApiData({
    reducerIsLoading: FETCH_MORE_LIKE_LOADING,
    reducerError: FETCH_MORE_LIKE_ERROR,
    extraDataObject: {
      pid: pid,
      series_id: series_id,
      num_results: num_results,
      genres: genres,
    },
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({
        type: FETCH_MORE_LIKE,
        payload: formatPersonalizeData(itemObj.data.more_like_x),
      });
    },
    urlOverride: `${myS4CPersonalizeBaseUrl()}/more_like_x`,
  });
}

export function setProfileChildFlag(flag) {
  localStorage.removeItem(localStorageIsChild);
  localStorage.setItem(localStorageIsChild, flag);
  return (dispatch, getState) => {
    dispatch({ type: PROFILE_IS_CHILD, payload: flag });
  };
}

function fetchMyS4CApiData({
  lang = null,
  method = 'POST',
  proc,
  reducerIsLoading,
  reducerError,
  extraDataObject = 0,
  dispatchSuccess = null,
  urlOverride,
}) {
  /*
     lang: current selected language
     method: pass over method POST, GET etc
     proc: action to pass over to the api like "get_current_username"
     reducerError: the reducer to use when not successful
     extraDataObject: pass extra data to the API
     dispatchSuccess: Function to call on success
     */
  const url = urlOverride ? urlOverride : myS4CBaseUrl();

  let data = {
    jsondata: buildAPIDataObject(lang, extraDataObject),
  };

  if (proc) {
    data.proc = 'bws_clic_api.' + proc;
  }

  function errorHandler(
    dispatch,
    errorCode,
    errorMessage,
    logErrorMessage = null
  ) {
    window.console.log(
      'MyS4CAPI::ERROR::' +
        errorMessage +
        '::' +
        logErrorMessage +
        '::' +
        errorCode
    );
    dispatch({ type: reducerError, payload: errorMessage });
    if (window.logError) {
      var logError =
        logErrorMessage && logErrorMessage !== 'undefined'
          ? logErrorMessage
          : errorMessage;
      // discount some common errors from e.g. error in login
      if (
        !errorCode ||
        (errorCode && !arrayContains(errorCode, MYS4C_ERROR_IGNORE))
      ) {
        window.logError(
          'Error MyS4CAPI ' + proc,
          encodeURIComponent(logError),
          'MyS4CActions.js'
        );
      }
    }
  }

  return function (dispatch, getState) {
    if (
      getState().auth.authenticated ||
      arrayContains(proc, MYS4C_UNAUTH_CALLS)
    ) {
      if (reducerIsLoading) dispatch({ type: reducerIsLoading, payload: true });
      if (reducerError) dispatch({ type: reducerError, payload: false });

      return fetch(url, {
        method: method,
        accept: 'application/json',
        body: JSON.stringify(data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (reducerIsLoading)
            dispatch({ type: reducerIsLoading, payload: false });
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.text())
        .then(
          (item) => {
            let itemObj = JSON.parse(item);
            let strings = getState().uiStrings[getState().curLang];
            if (itemObj.status === 'error' && itemObj.data) {
              const msgCode = itemObj.data.substring(0, 5);
              let msgLookup = strings[msgCode]
                ? strings[msgCode]
                : strings['genericError'] + ' (' + msgCode + ')';

              if (isUnauthErrorMessage(msgCode)) {
                errorHandler(
                  dispatch,
                  msgCode,
                  msgLookup,
                  decodeURIComponent(itemObj.data)
                );
                if (
                  getState().auth.authenticated ||
                  localStorage.getItem(localStorageAuthToken) ||
                  localStorage.getItem(localStorageAuthToken) !== null
                ) {
                  dispatch({ type: UNAUTH_USER });
                }
              } else if (msgCode.match(/^\d{5}$/)) {
                // if error code returned then lookup in ui strings then return, otherwise return error
                errorHandler(
                  dispatch,
                  msgCode,
                  msgLookup,
                  decodeURIComponent(itemObj.data)
                );
              } else {
                errorHandler(
                  dispatch,
                  msgCode,
                  decodeURIComponent(itemObj.data)
                );
              }
            } else if (itemObj.status === 'ok') {
              if (dispatchSuccess) dispatchSuccess(itemObj, dispatch);
            } else if (itemObj.status === 'maint') {
              // TODO: implement maintenance mode fail over
              dispatch({ type: UNAUTH_USER });
            } else {
              errorHandler(
                dispatch,
                null,
                strings['genericError'],
                decodeURIComponent(itemObj.data)
              );
            }
          },
          (error) => {
            if (reducerIsLoading)
              dispatch({ type: reducerIsLoading, payload: false });
            errorHandler(
              dispatch,
              null,
              getState().uiStrings[getState().curLang]['genericError'],
              'Error details unavailable'
            );
          }
        );
    }
  };
}
